import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["exportBtn"]

  toggle() {
    const anyChecked = this.element.querySelectorAll("input[type='checkbox']:checked").length > 0
    this.exportBtnTarget.disabled = !anyChecked
  }
}
